import React from "react";

import { CustomBadge, TextValue } from "./styles";

export type SimpleBadgeProps = {
  backgroundColor?: string;
  textColor?: string;
  value: string;
  dataCy?: string;
};

export const SimpleBadge = (props: SimpleBadgeProps) => {
  const { value, backgroundColor, textColor, dataCy } = props;

  return (
    <CustomBadge backgroundColor={backgroundColor}>
      <TextValue textColor={textColor} data-cy={dataCy}>
        {value}
      </TextValue>
    </CustomBadge>
  );
};
